
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/park-guide",
      function () {
        return require("private-next-pages/park-guide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/park-guide"])
      });
    }
  